import type { Theme } from '@mui/material/styles';

/**
 * sx-function for Typography elements that previously used
 * `color="secondary"` to tint body/heading text with the brand accent.
 *
 * Usage: `<Typography sx={TypographyStyleUtils.secondaryTextColorSx}>`
 * (omit the `color="secondary"` prop — sx replaces it here).
 *
 * Light mode: resolves to `palette.secondary.main` — byte-identical to the
 * pre-dark-mode `color="secondary"` prop behavior.
 *
 * Dark mode: resolves to `palette.text.primary` so headings and body text
 * stay readable on dark surfaces. Tenants' brand-accent `secondaryColor`
 * (often a dark navy or muted tone) would otherwise render near-invisible
 * against a dark `widgetBackgroundColor`.
 */
export function secondaryTextColorSx(theme: Theme) {
    return {
        color:
            theme.palette.mode === 'dark'
                ? theme.palette.text.primary
                : theme.palette.secondary.main,
    };
}

export default {
    secondaryTextColorSx,
};
